import { useEffect, useState } from 'react';

export enum DeviceType {
	Mobile = 'mobile',
	Tablet = 'tablet',
	Desktop = 'desktop',
}

const getDeviceType = (): DeviceType => {
	if (typeof window === 'undefined') return DeviceType.Desktop;
	const width = window.innerWidth;
	if (width > 0 && width <= 600) return DeviceType.Mobile;
	if (width >= 601 && width <= 1024) return DeviceType.Tablet;
	return DeviceType.Desktop;
};

export const useDeviceType = (): DeviceType => {
	const [device, setDevice] = useState<DeviceType>(DeviceType.Desktop);

	useEffect(() => {
		const updateDevice = () => {
			setDevice(getDeviceType());
		};

		const handleResizeOrOrientationChange = () => {
			updateDevice();
		};

		setDevice(getDeviceType());
		window.addEventListener('resize', handleResizeOrOrientationChange);
		window.addEventListener('orientationchange', handleResizeOrOrientationChange);

		return () => {
			window.removeEventListener('resize', handleResizeOrOrientationChange);
			window.removeEventListener('orientationchange', handleResizeOrOrientationChange);
		};
	}, []);

	return device;
};
